import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ContactsApi } from "../restapi/contactsApi";
import testIndexDB from "../db/indexdb";
import { DBManager } from "../db/dbManager";
import { DEBUG } from "../../../config";
import { enableMapSet } from 'immer';
import { updateContactSignUpNotification } from "../../../api/gramjs/methods";
import { DownloadAllContactGiaThuong, SaveContactConfig, SaveContactGiaThuong } from "../db/repository/contactRepo";
import { removeVietnameseAccent } from "../utils/common";
import { bignumber, divide, fraction, subtract } from "mathjs";
import Big from 'big.js';
import Decimal from "decimal.js";
import donViTien from "../contact/donViTien";
enableMapSet();


const initialState = {
    isLoading: false,
    isSaving: false,
    postContactAllInfoResponse: { errorCode: 0, responseText: "", data: {} },
    filterContactByType: "AllContacts",
    filterContactByText:"",
    contactArr: [],
    contactArrFull: [],
    contactIdLists: [], /** chỉ lưu danh sách id của contact, khi danh sách này không rỗng thì mới load lên để render
    dữ liệu để render lấy từ indexDB
    1: load toàn bộ contact từ máy chủ
    2: lưu vào indexdb
    3: lưu danh sách contact_id vào biến này
    4 sau khi có danh sách id thì load lên để render
    mỗi khi update hoặc sửa, xoá contact thì thao tác tại clien trước, sau đó mới  cập  nhật lên sv
    */
    contactGiaThuongArrMN: [],
    contactGiaThuongArrMB: [],
    contactGiaThuongArrMT: [],
    contactConfigArr: [], // tương ứng với contact hiện tại
    donViTien:[], // don vi tien dang edit của currentContact
    //currentSelectedContactIndex: 0, // contact được chọn ở contact list bằng click, hoặc gì đó
    currentContact: undefined,

    lastContactElementId: "contact-item:0",
    scrollTop: 0,
    contactGiaThuongMBChanged: {}, // mảng các bản ghi đã bị edit
    contactGiaThuongMTChanged: {}, // mảng các bản ghi đã bị edit
    contactGiaThuongMNChanged: {}, // mảng các bản ghi đã bị edit
    contactConfigChanged: {}, // mmảng các bản ghi đã bị edit
    contactChanged: undefined,// contact đã bị edit
    dmTinh: [],
    contactExtra: { contactId: 0, contact: {} }, // key= contact_id chứa dữ liệu số tin đến, đi
    hanMucJson: {},  //Lưu hạn mức nhận của khách
    hanMucRieng: {},// Hạn mức của 1 khách theo từng đài
    hanMucRiengChanged: {},// Hạn mức của 1 khách theo từng đài được edit
    daiMN: [],
    daiMNDaX: [],
    daiMT: [],
    daiMTDaX: [],
}

export const fetchContact = createAsyncThunk(
    "contact/getContact",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await ContactsApi.getContactsList();
            if (response.data.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.data.errorText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const fetchContactExtraInfo = createAsyncThunk(
    "contact/fetchContactExtraInfo",
    async (payload, { rejectWithValue }) => {
        try {

            const response = await ContactsApi.getContactsListExtraInfo(payload);
            if (response.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.errorText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const fetchContactGiaThuong = createAsyncThunk(
    "contact/getGiaThuong",
    async (payload, { rejectWithValue, getState }) => {
        try {
            // const contact = getState().contact.currentContact
            // const contactId = contact.contactId
            const response = await ContactsApi.getContactGiaThuong(payload);
            if (response.data.errorCode === 0) {
                return response;
            } else {
                return rejectWithValue(response.data.errorText);
            }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const postContactAllInfo = createAsyncThunk(
    "contact/postContactAllInfo",
    async (pl, { rejectWithValue, getState, dispatch }) => {
        try {
            /*payload: contact, []contactGiaThuong, []contactConfig*/
            const { applyAll, contactId } = pl;
            const arrGiaThuong = [];
            const arrConfig = [];
            const state = getState();
            const mb = Object.values(state.contact.contactGiaThuongMBChanged);
            const mt = Object.values(state.contact.contactGiaThuongMTChanged);
            const mn = Object.values(state.contact.contactGiaThuongMNChanged);
            const config = Object.values(state.contact.contactConfigChanged)
            const hanMuc = Object.values(state.contact.hanMucRiengChanged)
            const contact = []
            mb.map((item) => {
                arrGiaThuong.push(item)
            })
            mt.map((item) => {
                arrGiaThuong.push(item)
            })
            mn.map((item) => {
                arrGiaThuong.push(item)
            })
            config.map((item) => {
                arrConfig.push(item)
            })
            if (state.contact.contactChanged)
                contact.push(state.contact.contactChanged)
            const donViTienMap=new Map(state.contact.donViTien.map(item => [item.uSetValue, item]))
            const donViTien=[]
            for (let [key,val] of donViTienMap) {
                donViTien.push(val)
            }
            const payload = {
                contact: contact,
                giaThuong: arrGiaThuong,
                config: arrConfig,
                hanMuc: hanMuc,
                applyAll: applyAll,
                contactId: contactId,
                donViTien: donViTien,
            }
            // if (mb.length == 0 && mt.length == 0 && mn.length == 0
            //     && contact.length == 0 && config.length == 0 && hanMuc.length == 0) {
            //     dispatch(onNoDatachange())
            // }
            // else {
                const response = await ContactsApi.postEditedContact(payload);
                // dispatch(onDatachanged()) chuyển sang fullFilled
                return response;
            // }
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
function saveContactGiaThuongChangingTempDataMB(state, payload) {
    const { index, rowItem } = payload
    state.contactGiaThuongMBChanged[`${index}`] = rowItem
    return;
}
function saveContactGiaThuongChangingTempDataMT(state, payload) {
    const { index, rowItem } = payload
    state.contactGiaThuongMTChanged[`${index}`] = rowItem
}
function saveContactGiaThuongChangingTempDataMN(state, payload) {
    const { index, rowItem } = payload
    state.contactGiaThuongMNChanged[`${index}`] = rowItem
}
function getGiaFromLine(value /*number*/, line /*boolean*/) {
    if (!line) {
        return value;
    }
    value = new Decimal(value);  // Tạo một đối tượng Decimal với giá trị 100
    value = new Decimal(100).minus(value).div(100);  // Tính toán (100 - value) / 100
    value = Number(value)
    return value
}
export const contactSlice = createSlice({
    name: "contact",
    initialState,
    //Khai báo các action bên trong reducers, các action để làm thay đổi state khi dispatch
    reducers: {
        updateHanMucJson: (state, action) => {
            const { contactId, hanMucJson } = action.payload
            state.hanMucJson[contactId + ""] = hanMucJson
        },
        updateCurrentSelectedContact: (state, action) => {
            const { id, scrollTop } = action.payload
            state.currentContact = state.contactArr[id]
            state.scrollTop = scrollTop
            state.lastContactElementId = "contact-item:" + id// lưu lại index của item contact vừa bị click hoặc chọn
            if (DEBUG)
                console.log(state.currentContact)
        },

        updateGiaThuongMienBac: (state, action) => {
            let { index, fieldName, value } = action.payload
            if (fieldName == "lai") {
                fieldName = "gia"
                value = new Decimal(value);  // Tạo một đối tượng Decimal với giá trị 100
                value = new Decimal(100).minus(value).div(100);  // Tính toán (100 - value) / 100
                value = Number(value)
            }
            state.contactGiaThuongArrMB[index][fieldName] = value
            const rowItem = { ...state.contactGiaThuongArrMB[index] }
            saveContactGiaThuongChangingTempDataMB(state, { index, rowItem })

        },
        updateGiaThuongMienTrung: (state, action) => {
            let { index, fieldName, value } = action.payload
            if (fieldName == "lai") {
                fieldName = "gia"
                value = new Decimal(value);  // Tạo một đối tượng Decimal với giá trị 100
                value = new Decimal(100).minus(value).div(100);  // Tính toán (100 - value) / 100
                value = Number(value)
            }
            state.contactGiaThuongArrMT[index][fieldName] = value
            const rowItem = { ...state.contactGiaThuongArrMT[index] }
            saveContactGiaThuongChangingTempDataMT(state, { index, rowItem })
        },
        updateDonViTien: (state, action) => {
            let { donViTien } = action.payload
            state.donViTien = donViTien
        },
        checkAllTienHoi: (state, action) => {
            const { mien } = action.payload
            let index = 0;
            switch (mien) {
                case 1:
                    state.contactGiaThuongArrMB.forEach(item => {
                        if (item.hoi == 1)
                            item.hoi = 0
                        else
                            item.hoi = 1;
                        const data = { ...item }
                        saveContactGiaThuongChangingTempDataMB(state, { index, rowItem: data })
                        index++;
                    })
                    break;
                case 2:
                    state.contactGiaThuongArrMT.forEach(item => {
                        if (item.hoi == 1)
                            item.hoi = 0
                        else
                            item.hoi = 1;
                        const data = { ...item }
                        saveContactGiaThuongChangingTempDataMT(state, { index, rowItem: data })
                        index++;
                    })
                    break;
                case 3:
                    state.contactGiaThuongArrMN.forEach(item => {
                        if (item.hoi == 1)
                            item.hoi = 0
                        else
                            item.hoi = 1;
                        const data = { ...item }
                        saveContactGiaThuongChangingTempDataMN(state, { index, rowItem: data })
                        index++;
                    })
                    break;
            }
        },
        updateGiaThuongMienNam: (state, action) => {
            let { index, fieldName, value } = action.payload
            if (fieldName == "lai") {
                fieldName = "gia"
                value = new Decimal(value);  // Tạo một đối tượng Decimal với giá trị 100
                value = new Decimal(100).minus(value).div(100);  // Tính toán (100 - value) / 100
                value = Number(value)
            }
            state.contactGiaThuongArrMN[index][fieldName] = value
            const rowItem = { ...state.contactGiaThuongArrMN[index] }
            saveContactGiaThuongChangingTempDataMN(state, { index, rowItem })
        },
        updateBatchGiaThuong: (state, action) => {
            const payload = action.payload;
            const {line} = payload;
            let dataGiaThuong = state.contactGiaThuongArrMB;
            switch (payload.mien) {
                case 'MT':
                    dataGiaThuong = state.contactGiaThuongArrMT
                    break;
                case 'MN':
                    dataGiaThuong = state.contactGiaThuongArrMN
                    break;
            }
            for (let index = 0; index < dataGiaThuong.length; index++) {
                const loaiCuocId = dataGiaThuong[index]['loaiCuocId']
                switch (loaiCuocId) {
                    case 'DaT':
                        dataGiaThuong[index].gia =payload.value.giaDaT
                        dataGiaThuong[index].hsthuong = payload.value.thuongDaT
                        break;
                    case 'DaX':
                        dataGiaThuong[index].gia = payload.value.giaDaX
                        dataGiaThuong[index].hsthuong = payload.value.thuongDaX
                        break;
                    case 'XC':
                    case 'XcDau':
                    case 'XcDuoi':
                        dataGiaThuong[index].gia = payload.value.gia3C
                        dataGiaThuong[index].hsthuong = payload.value.thuong3C
                        break;
                    default:
                        if (loaiCuocId.endsWith("2C")) {
                            dataGiaThuong[index].gia = payload.value.gia2C
                            dataGiaThuong[index].hsthuong = payload.value.thuong2C
                        } else if (loaiCuocId.endsWith("3C")) {
                            dataGiaThuong[index].gia = payload.value.gia3C
                            dataGiaThuong[index].hsthuong = payload.value.thuong3C
                        } else if (loaiCuocId.endsWith("4C")) {
                            dataGiaThuong[index].gia = payload.value.gia4C
                            dataGiaThuong[index].hsthuong = payload.value.thuong4C
                        } else {
                            console.log(loaiCuocId);
                        }
                        break;
                }
                const rowItem = { ...dataGiaThuong[index] }
                switch (payload.mien) {
                    case 'MB':
                        saveContactGiaThuongChangingTempDataMB(state, { index, rowItem })
                        break;
                    case 'MT':
                        saveContactGiaThuongChangingTempDataMT(state, { index, rowItem })
                        break;
                    case 'MN':
                        saveContactGiaThuongChangingTempDataMN(state, { index, rowItem })
                        break;
                }

            }
        },
        updateContactData: (state, action) => {
            const { fieldName, value } = action.payload
            state.currentContact[fieldName] = value
            state.contactChanged = state.currentContact;
            const index = state.lastContactElementId.split(":")[1]
            state.contactArr[index] = { ...state.contactChanged }
            if (DEBUG)
                console.log(`fieldName:${fieldName}. value ${value}`)
        },
        updateContactConfig: (state, action) => {
            const { fieldName, value, tinhId, valueExtra } = action.payload
            let editIndex = 0;
            let editRow;
            for (let i = 0; i < state.contactConfigArr.length; i++) {
                const row = state.contactConfigArr[i]
                if (tinhId == row.tinhId) {
                    if (fieldName == "dauDuoiLenTo")
                        state.contactConfigArr[i][fieldName] = Number(value);
                    else if (fieldName == "maxVongDaXien")
                        state.contactConfigArr[i][fieldName] = Number(value);
                    else if (fieldName == "mienChiaTien1" || fieldName == "mienChiaTien2" || fieldName == "mienChiaTien4")
                        state.contactConfigArr[i]["mienChiaTien"] = Number(valueExtra);
                    else
                        state.contactConfigArr[i][fieldName] = value;
                    editIndex = i;
                    editRow = state.contactConfigArr[i];
                }
            }
            state.contactConfigChanged[`${editIndex}`] = editRow;
            if (DEBUG)
                console.log(`fieldName:${fieldName}. value ${value}`)
        },
        updateHanMucRieng: (state, action) => {
            const { key, nhanMax } = action.payload
            const updateRow = state.hanMucRieng[key]
            updateRow.nhanMax = nhanMax
            state.hanMucRiengChanged[key] = updateRow
        },
        loadDefaultContactConfig: (state, action) => {
            let editRow;
            const data = action.payload;
            let editIndex = 0;
            for (let i = 0; i < state.contactConfigArr.length; i++) {
                const row = state.contactConfigArr[i]
                if (data.tinhId == row.tinhId) {
                    state.contactConfigArr[i] = data;
                    editIndex = i;
                    editRow = state.contactConfigArr[i];
                }
            }
            state.contactConfigChanged[`${editIndex}`] = editRow;
        },
        onNoDatachange: (state, action) => {
            const apiRes = { errorCode: 0, responseText: "Dữ liệu không thay đổi" }
            state.postContactAllInfoResponse = apiRes
            state.isSaving = false
        }, // hàm này bỏ không sử dụng
        onDatachanged: (state, action) => {
            state.hanMucRiengChanged = {} // lưu xong thì xoá đi
            state.isSaving = false
        },
        addNewContact: (state, action) => {
            const newContact = action.payload
            state.contactArr.push(newContact)
            const index = state.contactArr.length - 1
            state.contactIdLists.push(index)

            state.currentContact = state.contactArr[index]
            state.lastContactElementId = "contact-item:" + index// lưu lại index của item contact vừa bị click hoặc chọn
        },
        removeCurrentContact: (state, action) => {
            let index = state.contactArr.indexOf(state.currentContact)
            if (index < 0)
                for (let i = 0; i < state.contactArr.length; i++) {
                    const item = state.contactArr[i]
                    if (item.contactId == state.currentContact.contactId) {
                        index = i;
                        break;
                    }
                }
            if (index < 0) {
                console.log('remove index <0, error');
                return
            }
            state.contactArr.splice(index, 1)
            state.contactIdLists.splice(index, 1)
            if (index > 0) {
                state.currentContact = state.contactArr[index - 1]
                state.lastContactElementId = "contact-item:" + (index - 1)
            }
        },
        filterContact: (state, action) => {
            const { filter } = action.payload
            state.filterContactByText = filter
            const sfilter = removeVietnameseAccent(filter.toLowerCase())
            const tmp = state.contactArrFull.filter(item => {
                const text = removeVietnameseAccent((item.name + " " + item.phone + " " + item.tlUserId).toLowerCase())
                let isMatch = (text.includes(sfilter))
                if (state.filterContactByType == "AllContacts") {
                    return isMatch 
                } else if (state.filterContactByType == "CustomerContacts") {
                    return isMatch && item.role == 1
                } else if (state.filterContactByType == "SupplierContacts") {
                    return isMatch && item.role == 2
                }
                return isMatch

            })
            state.contactArr = tmp
            state.contactIdLists = []
            state.contactArr.map((item, index) => {
                state.contactIdLists.push(index)
            })
            state.currentContact = undefined
        },
        filterContactByType: (state, action) => {
            const oldFillter = state.filterContactByType
            const { filterByType } = action.payload
            state.filterContactByType = filterByType
            const tmp = state.contactArrFull.filter(item => {
                let isMatch= true;
                if (state.filterContactByText != "") {
                    const text = removeVietnameseAccent((item.name + " " + item.phone + " " + item.tlUserId).toLowerCase())
                    isMatch = (text.includes(state.filterContactByText))
                }
                if (filterByType == "AllContacts") {
                    return isMatch
                } else if (filterByType == "CustomerContacts") {
                    return isMatch && item.role == 1
                } else if (filterByType == "SupplierContacts") {
                    return isMatch && item.role == 2
                }
                return false
            })
            state.contactArr = tmp
            state.contactIdLists = []
            state.contactArr.map((item, index) => {
                state.contactIdLists.push(index)
            })
            if (oldFillter != filterByType) {
                state.currentContact = undefined
            }
           
        },
        updateContactOrder: (state, action) => {
            const { order,ct1,ct2 } = action.payload
            state.contactIdLists = [...order]
            state.contactArrFull.find((item) => {
                if (item.contactId == ct1.contactId) {
                    item.sortOrder = ct2.sortOrder
                }
                if (item.contactId == ct2.contactId) {
                    item.sortOrder = ct1.sortOrder
                }
            })
            state.contactArr.find((item) => {
                if (item.contactId == ct1.contactId) {
                    item.sortOrder = ct2.sortOrder
                }
                if (item.contactId == ct2.contactId) {
                    item.sortOrder = ct1.sortOrder
                }
            })
        }
    },
    extraReducers: (builder) => {
        // Bắt đầu thực hiện action getContact (Promise pending)
        builder.addCase(fetchContact.pending, (state) => {
            state.isLoading = true;
            //console.log("Bắt đầu thực hiện action getContact (Promise pending)")
        });
        // Khi thực hiện action getContact thành công (Promise fulfilled)
        builder.addCase(fetchContact.fulfilled, (state, action) => {
            //console.log("Khi thực hiện action getContact thành công (Promise fulfilled)")
            const tmp = action.payload.data.data ? [...action.payload.data.data] : []

            DBManager.getDBConnection().then((dbConnection) => {
                // Kết nối đã được mở và có thể sử dụng dbConnection trong toàn bộ ứng dụng
                // Ví dụ: thêm bản ghi vào object store
                const transaction = dbConnection.transaction("contacts", "readwrite");
                const objectStore = transaction.objectStore("contacts");
                tmp.map((contact) => {
                    // var customerData = {
                    //     userId: contact.userId,
                    //     contactId: contact.contactId,
                    //     phone: contact.phone,
                    //     ngoi1: contact.ngoi1,
                    //     ngoi2: contact.ngoi2,
                    //     tlUserId: contact.tlUserId,
                    //     name: contact.name,
                    // }
                    objectStore.put(contact);
                    //console.log(contact)
                });


                transaction.oncomplete = () => {
                    if (DEBUG)
                        console.log("Thêm bản ghi thành công!");
                };

                transaction.onerror = (event) => {
                    if (DEBUG)
                        console.error("Lỗi khi thêm bản ghi: ", (event.target).error);
                };
            })
                .catch((error) => {
                    console.error("Lỗi khi mở kết nối: ", error);
                });
            let tmpId = []
            let tmpMap = []
            tmp.map((item, index) => {
                tmpId.push(index)
                tmpMap.push(item)
            })
            state.contactArrFull = Object.assign(tmpMap)
            //
            if (state.filterContactByType == "AllContacts") {
                state.contactArr = tmpMap
               
                state.contactIdLists = [...tmpId]
            } else if (state.filterContactByType == "CustomerContacts") {
                state.contactArr = tmpMap.filter(item => item.role == 1)
        
                for (let i = 0; i < tmpMap.length; i++) {
                    if (tmpMap[i].role == 1) {
                        tmpId.push(i)
                    }
                }
                 
            } else if (state.filterContactByType == "SupplierContacts") {
                state.contactArr = tmpMap.filter(item => item.role == 2)
              
                for (let i = 0; i < tmpMap.length; i++) {
                    if (tmpMap[i].role == 2) {
                        tmpId.push(i)
                    }
                }
            }

            // reset các biến tạm lưu sự thay đổi
            state.contactGiaThuongMBChanged = {} // mảng các bản ghi đã bị edit
            state.contactGiaThuongMTChanged = {} // mảng các bản ghi đã bị edit
            state.contactGiaThuongMNChanged = {} // mảng các bản ghi đã bị edit
            state.contactConfigChanged = {} // mmảng các bản ghi đã bị edit
            state.contactChanged = undefined// contact đã bị edit

        });
        // Khi thực hiện action getContact thất bại (Promise rejected)
        builder.addCase(fetchContact.rejected, (state, action) => {
            state.isLoading = false;
            if (DEBUG)
                console.log("Khi thực hiện action getContact thất bại (Promise rejected)")
        });
        //Giá thưởng
        builder.addCase(fetchContactGiaThuong.fulfilled, (state, action) => {
            const listGiaThuong = action.payload.data.data.giaThuong
            state.contactGiaThuongArrMN = []
            state.contactGiaThuongArrMB = []
            state.contactGiaThuongArrMT = []
            const contactConfig = action.payload.data.data.config
            state.contactConfigArr = contactConfig
            state.dmTinh = action.payload.data.data.dmTinh
            state.hanMucRieng = action.payload.data.data.hanMucRieng
            state.daiMN = action.payload.data.data.daiMn
            state.daiMNDaX = action.payload.data.data.daiMNDaX
            state.daiMT = action.payload.data.data.daiMt
            state.daiMTDaX = action.payload.data.data.daiMTDaX
            state.donViTien = action.payload.data.data.donViTien
            state.hanMucRiengChanged = {}
            if (listGiaThuong) {
                listGiaThuong.map((item) => {
                    if (item.mienDaiCuocId == 3)
                        state.contactGiaThuongArrMN.push(item)
                    else if (item.mienDaiCuocId == 2)
                        state.contactGiaThuongArrMT.push(item)
                    else state.contactGiaThuongArrMB.push(item)
                })
                SaveContactGiaThuong(listGiaThuong)
            }
            if (contactConfig) {
                SaveContactConfig(contactConfig)
            }
            state.isLoading = false;
            // lưu các giá trị để so sánh, nếu thay đổi thì up sv
            state.contactGiaThuongOrigin = { ...state.contactGiaThuongArrMB }
        }
        );

        //update contact All info
        builder.addCase(postContactAllInfo.pending, (state) => {
            //state.postContactAllInfoResponse=action.payload
            state.isSaving = true;
        });
        builder.addCase(postContactAllInfo.rejected, (state, action) => {
            state.isSaving = false;
            state.postContactAllInfoResponse = action.payload
        });
        builder.addCase(postContactAllInfo.fulfilled, (state, action) => {
            state.isSaving = false;
            if (action.payload) {
                state.postContactAllInfoResponse = action.payload
                state.hanMucRiengChanged = {} // lưu xong thì xoá đi
                state.isSaving = false
                //onDatachanged();
            }
        });
        //fetchContactExtraInfo
        builder.addCase(fetchContactExtraInfo.pending, (state) => {

        });
        builder.addCase(fetchContactExtraInfo.fulfilled, (state, action) => {
            const data = action.payload.data
            state.contactExtra = {}
            if (data != null) {
                data.map((item) => {
                    state.contactExtra[item.contactId] = item
                })
            }
            console.log('nap xong contact extra')
        })
        builder.addCase(fetchContactExtraInfo.rejected, (state, action) => {

        })
    },
});
export const { updateCurrentSelectedContact, updateViewportIds,
    updateGiaThuongMienBac, updateGiaThuongMienTrung, updateGiaThuongMienNam
    , updateContactData, updateContactConfig, onNoDatachange, addNewContact,
    loadDefaultContactConfig, removeCurrentContact, filterContact, checkAllTienHoi,
    updateHanMucJson, updateHanMucRieng, onDatachanged, updateBatchGiaThuong,updateDonViTien, updateContactOrder, filterContactByType } = contactSlice.actions;

export default contactSlice.reducer;